/**
 * @flow
 * @relayHash d27c31eb52dad8c00d261134e6c23923
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddUpdateMachineTypeModal_machineType$ref = any;
type DeleteMachineTypeModal_machineType$ref = any;
export type MachineTypesQueryVariables = {||};
export type MachineTypesQueryResponse = {|
  +machineTypes: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +name: string,
        +$fragmentRefs: AddUpdateMachineTypeModal_machineType$ref & DeleteMachineTypeModal_machineType$ref,
      |}
    |}>
  |}
|};
export type MachineTypesQuery = {|
  variables: MachineTypesQueryVariables,
  response: MachineTypesQueryResponse,
|};
*/


/*
query MachineTypesQuery {
  machineTypes {
    edges {
      node {
        id
        name
        ...AddUpdateMachineTypeModal_machineType
        ...DeleteMachineTypeModal_machineType
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment AddUpdateMachineTypeModal_machineType on MachineType {
  id
  name
}

fragment DeleteMachineTypeModal_machineType on MachineType {
  id
  name
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MachineTypesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "machineTypes",
        "name": "__MachineTypes_machineTypes_connection",
        "storageKey": null,
        "args": null,
        "concreteType": "MachineTypeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "MachineTypeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MachineType",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "AddUpdateMachineTypeModal_machineType",
                    "args": null
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "DeleteMachineTypeModal_machineType",
                    "args": null
                  }
                ]
              },
              (v3/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "MachineTypesQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "machineTypes",
        "storageKey": null,
        "args": null,
        "concreteType": "MachineTypeConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "MachineTypeEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "MachineType",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/)
                ]
              },
              (v3/*: any*/)
            ]
          },
          (v4/*: any*/)
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "machineTypes",
        "args": null,
        "handle": "connection",
        "key": "MachineTypes_machineTypes",
        "filters": []
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "MachineTypesQuery",
    "id": null,
    "text": "query MachineTypesQuery {\n  machineTypes {\n    edges {\n      node {\n        id\n        name\n        ...AddUpdateMachineTypeModal_machineType\n        ...DeleteMachineTypeModal_machineType\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment AddUpdateMachineTypeModal_machineType on MachineType {\n  id\n  name\n}\n\nfragment DeleteMachineTypeModal_machineType on MachineType {\n  id\n  name\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "machineTypes"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '691af63e93728b1fbccfc7ae7912445e';
module.exports = node;
